import { RadioButton } from "@root/shared/components/RadioButton";
import { LoadingModal } from "@clientFrontend/features/scout/components/LoadingModal";
import { PopOver } from "@root/shared/components/PopOver";
import { Icon } from "@root/shared/components/Icon";
import { useState } from "react";
import { ToolTip } from "@root/shared/components/ToolTip";
import { type AutoSelectStatus } from "@clientFrontend/features/scout/components/ScoutTargetAndWorkSelector/useAutoSelectWork";
import * as styles from "./styles.css";

export type AutoSelectorProps = {
  currentWorkId: string | undefined; // NOTE: おまかせ選択の場合は "auto"
  autoSelectStatus: AutoSelectStatus;
  onAutoSelect: () => void;
  onSelfSelect: () => void;
  autoSelectDisabledMessage?: string;
  isSp: boolean;
};

export const AutoSelector = (props: AutoSelectorProps) => {
  const {
    currentWorkId,
    autoSelectStatus,
    onAutoSelect,
    onSelfSelect,
    autoSelectDisabledMessage,
    isSp,
  } = props;

  const [tooltipVisible, setTooltipVisible] = useState(false);
  const toggleTooltip = () => setTooltipVisible(!tooltipVisible);

  return (
    <div className={styles.container}>
      {autoSelectStatus === "loading" && (
        <LoadingModal title="求人を選択中..." description="1分程度かかることがあります" />
      )}
      {autoSelectStatus === "completed" && (
        <div className={styles.autoSelectCompletedPopoverContainer}>
          <PopOver
            key={`auto-select-completed-popover-${autoSelectStatus}`}
            arrowPosition={isSp ? "topLeft" : "leftMiddle"}
          >
            求人選択が完了しました。
          </PopOver>
        </div>
      )}
      <div className={styles.autoSelectCheckboxContainer}>
        <div className={styles.autoSelectOuter}>
          <RadioButton
            id="auto-select-radio"
            label={
              <div className={styles.autoSelectCheckboxLabelContainer}>
                おまかせ（自動で選択する）
              </div>
            }
            checked={currentWorkId === "auto"}
            onChange={onAutoSelect}
            disabled={!!autoSelectDisabledMessage}
          />
          {!autoSelectDisabledMessage && (
            // TODO: 以下PRのTooltipTriggerコンポーネントが完成したら差し替える
            // https://github.com/rejob/rejob-v2/pull/22708
            <div
              {...(isSp
                ? { onClick: toggleTooltip }
                : { onMouseEnter: toggleTooltip, onMouseLeave: toggleTooltip })}
              className={styles.toolTipOuter}
            >
              <Icon name="tooltip" fontSize="16px" color="#575757" />
              <div className={styles.toolTip({ isVisible: tooltipVisible })}>
                <ToolTip isHovered arrowPosition={isSp ? "topCenter" : "leftTop"}>
                  <p className={styles.toolTipsParagraph}>
                    <strong>
                      選択した求職者一人ひとりに、マッチする求人を自動で一つ選択します。
                    </strong>
                  </p>
                  <p className={styles.toolTipsParagraph}>
                    求職者の希望職種・経験・住所から判断した、スカウトへの応募可能性が高い求人を割り振ります。
                  </p>
                  <ul className={styles.toolTipList}>
                    <li>
                      ※店長、エリアマネージャー、講師・インストラクター等の役職の求人は対象外です。
                    </li>
                    <li>※ブランドでのマッチ判定はしません。</li>
                    <li>※店舗・都道府県の指定はできません。</li>
                  </ul>
                </ToolTip>
              </div>
            </div>
          )}
        </div>
        {autoSelectDisabledMessage && (
          <div className={styles.selectUserNotice}>
            <Icon name="information" fontSize="16px" color="#575757" />
            {autoSelectDisabledMessage}
          </div>
        )}
      </div>
      <RadioButton
        id="self-select-radio"
        label="自分で選択する"
        checked={currentWorkId !== "auto"}
        onChange={onSelfSelect}
      />
    </div>
  );
};
